import { LoanCaseDTO, ProductInstanceDTO } from "@smartx/mikro-vt-client-api"
import { Fragment } from "react"
import { IField } from "../../../components/DataList/DataList"
import { isEhProduct } from "../../../functions/helpers"
import { useProductFieldLabelUtil } from "../../../hooks/useGetProductFieldLabel"
import { DataListComponent } from "../../../Shared"

interface OverviewContractProps {
  loanCaseData: LoanCaseDTO
}

const OverviewContract: React.FC<OverviewContractProps> = ({
  loanCaseData,
}) => {
  const { productFieldLabelUtil: getLabel } = useProductFieldLabelUtil()

  const getProductFieldArray = (product: ProductInstanceDTO): Array<IField> => {
    const isEh = isEhProduct(product)

    const fields: IField[] = [
      {
        label: getLabel(product, "contractDate"),
        value: product.contractDate,
        fieldType: "date",
      },
      {
        label: getLabel(product, "expiryDate"),
        value: product.expiryDate,
        fieldType: "date",
      },
    ]

    if (isEh) {
      fields.push(
        {
          label: getLabel(product, "availabilityStart"),
          value: product.availabilityStart,
          fieldType: "date",
        },
        {
          label: getLabel(product, "availabilityEnd"),
          value: product.availabilityEnd,
          fieldType: "date",
        },
        {
          label: getLabel(product, "gracePeriodStart"),
          value: product.gracePeriodStart,
          fieldType: "date",
        },
        {
          label: getLabel(product, "gracePeriodEnd"),
          value: product.gracePeriodEnd,
          fieldType: "date",
        },
        {
          label: getLabel(product, "paymentFreq"),
          value: product.paymentFreq,
          fieldType: "CVT",
          list: "MIKRO_REPAYMENT_FREQUENCY_LIST",
        },
        {
          label: getLabel(product, "firstCapitalPaymentDate"),
          value: product.firstCapitalPaymentDate,
          fieldType: "date",
        },
        {
          label: getLabel(product, "capitalPaymentAmount"),
          value: product.capitalPaymentAmount,
          fieldType: "number",
        },
        {
          label: getLabel(product, "lastCapitalPaymentAmount"),
          value: product.lastCapitalPaymentAmount,
          fieldType: "number",
        },
      )
    }

    fields.push(
      {
        label: getLabel(product, "moratoriumActive"),
        value: product.moratoriumActive,
        fieldType: "yesno",
      },
      {
        label: getLabel(product, "moratoriumExpiryDate"),
        value: product.moratoriumExpiryDate,
        fieldType: "date",
      },
    )

    return fields
  }

  return (
    <>
      {loanCaseData.productInstances.map((product: ProductInstanceDTO) => {
        return (
          <Fragment
            key={`contract-${loanCaseData.caseId}-${product.productCode}`}
          >
            <DataListComponent dataList={getProductFieldArray(product)} />
          </Fragment>
        )
      })}
    </>
  )
}

export default OverviewContract
